// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"titleContainer__pQnlC","title":"title__SuVkI","episodeCount":"episodeCount__2I4CR","imageContainer":"imageContainer__1Y-Zp"};